<template>
    <article class="tarjeta">
        <div class="tarjeta__cabecera">
            <div class="tarjeta__sello" :class="{'tarjeta__sello--mal': !constancia.vigente}">
                <v-icon>description</v-icon>
            </div>
            <div>
                <h3 class="tarjeta__titulo">{{ constancia.constancia_codigo }}</h3>
                <span class="tarjeta__estado" :class="constancia.aprobado ? 'tarjeta__estado--bien' : 'tarjeta__estado--espera'">{{ constancia.tipo }}</span>
                <span class="tarjeta__estado ml-1" :class="constancia.vigente ? 'tarjeta__estado--bien' : 'tarjeta__estado--mal'">
                    {{ constancia.vigente ? 'Vigente' : 'Vencida' }}
                </span>
            </div>
        </div>

        <ul class="tarjeta__datos">
            <li>
                <v-icon>event</v-icon>
                <span>Emitida el {{ constancia.fecha_emitida | fechaESP }}</span>
            </li>
            <li>
                <v-icon>event_busy</v-icon>
                <span v-if="constancia.vigente">Válida hasta el <strong>{{ constancia.fecha_validez | fechaESP }}</strong>
                    <template v-if="constancia.dias_restantes <= 7"> ({{ constancia.dias_restantes == 0 ? 'vence hoy' : `${constancia.dias_restantes} días` }})</template>
                </span>
                <span v-else>Venció el <strong>{{ constancia.fecha_validez | fechaESP }}</strong></span>
            </li>
            <li v-if="constancia.unidad_operativa">
                <v-icon>business</v-icon>
                <span>{{ constancia.unidad_operativa }}</span>
            </li>
            <li>
                <v-icon>school</v-icon>
                <span>{{ constancia.conteo_cursos }} {{ constancia.conteo_cursos == 1 ? 'curso' : 'cursos' }}</span>
            </li>
            <li v-if="constancia.cursos && constancia.cursos.length">
                <ul class="tarjeta__cursos" style="width: 100%">
                    <li v-for="(curso, i) in constancia.cursos" :key="i">{{ curso.nombre_curso }}</li>
                </ul>
            </li>
        </ul>

        <v-btn block depressed color="primary" v-if="constancia.vigente" @click="$emit('descargar', constancia)">
            <v-icon left>download</v-icon>
            Descargar constancia
        </v-btn>
        <div class="tarjeta__aviso" v-else>
            <v-icon small>info</v-icon> Venció: si la necesita, solicite una constancia nueva.
        </div>
    </article>
</template>

<script>
/** Tarjeta de una constancia del participante. Emite "descargar" con la constancia. */
export default {
    name: "TarjetaConstancia",
    props: {
        constancia: {type: Object, required: true},
    },
}
</script>

<style lang="scss" scoped>
@import "./tarjetas.scss";
</style>
